import * as React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SettingsIcon from '@mui/icons-material/Settings';
import PrimaryButton from '../Button/PrimaryButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { GlobalStates } from '../../GlobalStates';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


const ApklausaSumm = ({ id, data, create }) => {

    const navigate = useNavigate();
    const { token, path } = React.useContext(GlobalStates)
    const { t } = useTranslation()

    const edit = async (id) => {
        let ObjectInfo = { token: token, path: path, what: 'formos-tipai' }
        navigate('/Apklausos/' + id, { state: { id: id, ObjectInfo: ObjectInfo } })
    }

    return (

        <div className='row AccordionButtons apklausaSumm'>
            <div className='row apklausaSummIkonos'>
                <div className='column pointer ikonosName' onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault();
                    create()
                }}>
                    <ContentCopyIcon
                        style={{ fill: "#665AE1" }}
                        className='margin'

                    />
                    {t('kopijuoti')}
                </div>
                <div className='column pointer ikonosName'>
                    <SettingsIcon
                        className='margin'
                        onClick={(e) => {
                            e.stopPropagation()

                            edit(id)
                        }}
                        style={{ fill: "#665AE1" }} />
                    {t('redaguoti')}

                </div>
            </div>
            <PrimaryButton
                onClick={() => {
                    navigate("/Rezultatai", {
                        state: {
                            filter: { kasPildo: data.kasPildo }
                        }
                    })
                }}
                className='margin isDidz'
                endIcon={< ArrowForwardIcon />}
                text='Peržiūrėti statistiką'
            />
        </div>

    )
}
export default ApklausaSumm
